import { createContext } from 'react';

import { EFGTransferringInfo } from './model';

//todo rebuild on Like in File Store
export const EFGTransferringInfoContext = createContext<EFGTransferringInfo>(
  new EFGTransferringInfo(),
);
